
export const getFormattedDateTime = (): string => {
  const now = new Date();
  
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  
  const dayNames = ['일', '월', '화', '수', '목', '금', '토'];
  const dayName = dayNames[now.getDay()];
  
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');

  // 주차 계산 (ISO-8601 방식과 유사한 한국식 주차 계산)
  const currentDate = new Date(year, now.getMonth(), now.getDate());
  const firstDayOfYear = new Date(year, 0, 1);
  const pastDays = (currentDate.getTime() - firstDayOfYear.getTime()) / 86400000;
  const weekNumber = Math.ceil((pastDays + firstDayOfYear.getDay() + 1) / 7);

  return `${year}년 ${month}월 ${day}일 (${dayName}) ${hours}:${minutes}:${seconds} [${weekNumber}주차]`;
};
